import { render } from "./IngresosPage.vue?vue&type=template&id=37d18046&scoped=true"
import script from "./IngresosPage.vue?vue&type=script&lang=js"
export * from "./IngresosPage.vue?vue&type=script&lang=js"

import "./IngresosPage.vue?vue&type=style&index=0&id=37d18046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d18046"]])

export default __exports__